import { Component, OnInit,HostListener } from '@angular/core';
import { LocalStorage } from './services/local-storage';
import { PopupLogoutComponent } from './users/popup/popup-logout.component';
import {FeedtrackingComponent} from './feedtracking/feedtracking.component'
import { SharedService } from './services/shared.service';
// import {AngularIndexedDB} from 'angular2-indexeddb';
import {Observable} from 'rxjs/Observable';
import { ObjectStore } from './models/object-store';
import { Entity, Todo } from './models/entity';
import {IndexedDBService} from './services/indexdb.service';
import { TodoComponent } from './todo.component';
//import {} from '@types/googlemaps';
import {autologout} from './services/autologout.service';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { Router } from '@angular/router';
// declare var OneSignal: any;

//import * as OneSignal from 'assets/js/OneSignalSDK.js';

@Component({
  selector: 'app-root',
  template: `
    <!-- Router Outlet -->
    <router-outlet></router-outlet>   
    
  `,
      providers: [PopupLogoutComponent, FeedtrackingComponent, SharedService, IndexedDBService,ObjectStore, autologout]
})
export class AppComponent  {
  title = 'app works!';
 @HostListener("window:onbeforeunload",["$event"])
 
public webRobot: boolean = false;
  private static AM_I_ROBOTS:any = ['googlebot', 'twitterbot', 'facebookexternalhit', 'google.com/bot.html',
    'facebook.com/externalhit_uatext.php', 'tweetmemebot', 'sitebot', 'msnbot', 'robot',
    'bot', 'spider', 'crawl'];
  constructor(private localstorage : LocalStorage, private feedtracking: FeedtrackingComponent, public indexedDB: IndexedDBService, private objectstore: ObjectStore, private sharedservice:SharedService, private _autologout: autologout, private router: Router) {
   console.log("App Component") 
  // _socketService.init();


  }

  ngOnInit() {
      this.init();    
      this.router.events.subscribe((event) => {
        if(event.constructor.name === "NavigationEnd") {
          this. _autologout.init();
        } 
      }); 
}

   clearLocalStorage(event){
      console.log("clearLocalStorage");
        localStorage.clear();
        this.localstorage.clearAll();
    }
init() {
    const robots = AppComponent.AM_I_ROBOTS;
    const ua = navigator.userAgent.toLowerCase();
    for (var i = 0, len = robots.length; i < len; i++) {
      if(ua.indexOf(robots[i]) !== -1  ) {
        this.webRobot = true;
        break;
      }
    }

     }
 
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts